import React, {Fragment} from "react";
import ImageRadioPicker from "../../../components/ImageRadioPicker";
import PropTypes from "prop-types";
import imageT2 from '../../../images/situation/hengtype/T2.jpg';
import imageL2 from '../../../images/situation/hengtype/L2.jpg';
import imageH2 from '../../../images/situation/hengtype/H2.jpg';
import imageT3 from '../../../images/situation/hengtype/T3.jpg';
import imageL3 from '../../../images/situation/hengtype/L3.jpg';
import imageHT3 from '../../../images/situation/hengtype/HT3.jpg';
import imageLT3 from '../../../images/situation/hengtype/LT3.jpg';
import {HengType} from "../../../Model";

export default function HengtypeWindow(props) {
    return <Fragment>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.T2}
                          image={imageT2}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.L2}
                          image={imageL2}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.H2}
                          image={imageH2}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.T3}
                          image={imageT3}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.L3}
                          image={imageL3}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.HT3}
                          image={imageHT3}/>
        <ImageRadioPicker onSelect={props.onChange}
                          current={props.currentValue}
                          value={HengType.LT3}
                          image={imageLT3}/>
    </Fragment>
}

HengtypeWindow.propTypes = {
    currentValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}